export default __webpack_public_path__ + "static/media/elena_ikumapayi.47f1f6d4.m4a";